module.exports = __webpack_public_path__ + "static/img/ent-86.7621e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-86.jpg
// module id = s+k3
// module chunks = 51